<template>
  <v-row>
    <v-col
      cols="12"
      md="6"
    >
      <v-card
        class="pt-0 mb-md-6 h-md-100"
        rounded="lg"
        variant="outlined"
        color="ui-kit-bg-gray-60"
      >
        <div class="px-4 pb-6 px-md-6 pb-md-8">
          <v-card-title
            class="text-ui-kit-text px-0 pt-4 pb-3 pt-md-6 pb-md-4 text-subtitle-1 text-md-landing-h6"
          >
            Фактический адрес
          </v-card-title>
          <p class="text-address text-ui-kit-text text-body-1 mb-2">
            {{ infoByCountry.address }}
          </p>
          <p class="text-ui-kit-text text-body-1 mb-0">
            {{ infoByCountry.workingHours }}
          </p>
        </div>
      </v-card>
    </v-col>

    <v-col
      cols="12"
      md="6"
    >
      <v-card
        v-if="infoByCountry.postAddress"
        class="pt-0 mb-md-6 h-md-100"
        rounded="lg"
        variant="outlined"
        color="ui-kit-bg-gray-60"
      >
        <div class="px-4 pb-6 px-md-6 pb-md-8">
          <v-card-title class="text-ui-kit-text px-0 pt-6 pb-3 pb-md-4 text-subtitle-1 text-md-landing-h6">
            Почтовый адрес
          </v-card-title>
          <p class="text-ui-kit-text text-body-1 mb-0">
            {{ infoByCountry.postAddress }}
          </p>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { INFO } from '~/features/contacts/constants'

const { currentCountry } = storeToRefs(useAppLocale())

const infoByCountry = computed(() => {
  return INFO[currentCountry.value]
})
</script>

<style scoped lang="scss">
.text-address {
  max-width: 460px;
}

.image-desktop {
  position: absolute;
  inset: 0;
  pointer-events: none;
}
</style>

